import { CustomJsonComponentConfig } from '@apps/websiteCustomJsonComponents/config';
import { createLazyComponentFromNamedExport } from '@shared/utils/createLazyComponent';
import { ThingsToDoGrabber } from './ThingsToDoSidebar';

// Lazy load view components
const ThingsToDoAdd = createLazyComponentFromNamedExport(() => import(/* webpackChunkName: "content/websiteEditorThingsToDoAdd" */ './ThingsToDoSidebar'), 'ThingsToDoAdd');

const ThingsToDoEdit = createLazyComponentFromNamedExport(() => import(/* webpackChunkName: "content/websiteEditorThingsToDoEdit" */ './ThingsToDoEdit'), 'ThingsToDoEdit');

const ThingsToDoGuest = createLazyComponentFromNamedExport(() => import(/* webpackChunkName: "content/websiteEditorThingsToDoGuest" */ './ThingsToDoGuest'), 'ThingsToDoGuest');

// Add this object to CUSTOM_JSON_COMPONENT_TYPES in
// src/apps/websiteCustomJsonComponents/config.ts
export const ThingsToDoConfig: CustomJsonComponentConfig = {
  // Tip:
  // Replace this with the URL for the JSONSchema your component data uses.
  // This makes sure PageComponents with this schema will render your components.
  schemaUrl: 'https://withjoy.com/assets/public/schemas/ThingsToDo_v1.7.0.json',
  componentType: 'ThingsToDo',
  adminSidebarComponent: {
    addComponentView: ThingsToDoAdd,
    dragComponentView: ThingsToDoGrabber,
    editComponentView: ThingsToDoEdit,
    createComponentView: ThingsToDoEdit,
  },
  guestSiteComponent: ThingsToDoGuest,
};
